import { render, staticRenderFns } from "./CameraDesktop.vue?vue&type=template&id=3166ab92&scoped=true&"
import script from "./CameraDesktop.vue?vue&type=script&lang=js&"
export * from "./CameraDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CameraDesktop.vue?vue&type=style&index=0&id=3166ab92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166ab92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSheet,VSlideGroup,VSlideItem})
